import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { uploadDictionary } from "../util/wordywhiz";

function Upload() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    file: null,
    title: "",
    description: "",
    isPublic: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  async function submitHandler(e) {
    e.preventDefault();
    if (!form.file) {
      setError("Please select a CSV file.");
      return;
    }
    setIsLoading(true);
    setError("");
    try {
      await uploadDictionary(form);
      navigate("/wordy-whiz/my-dictionaries");
    } catch {
      setError("Upload failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="study-header">
        <p className="study-eyebrow">Wordy Whiz · Learn</p>
        <h1>Upload Dictionary</h1>
      </div>
      <p className="auth-hint">
        Upload a CSV of words you'd like to study. Only CSV files are accepted.
        Each CSV should contain one word per row. Only words in the first
        column will be used.
      </p>

      {error && <p className="auth-error">{error}</p>}

      {isLoading ? (
        <div className="dict-spinner" />
      ) : (
        <form className="auth-form" onSubmit={submitHandler}>
          <label className="auth-field">
            <span className="ww-label">Title</span>
            <input
              className="auth-input"
              required
              value={form.title}
              onChange={(e) => setForm((c) => ({ ...c, title: e.target.value }))}
            />
          </label>

          <label className="auth-field">
            <span className="ww-label">Description</span>
            <textarea
              className="auth-input"
              rows={3}
              value={form.description}
              onChange={(e) => setForm((c) => ({ ...c, description: e.target.value }))}
            />
          </label>

          <label className="auth-check">
            <input
              type="checkbox"
              checked={form.isPublic}
              onChange={(e) => setForm((c) => ({ ...c, isPublic: e.target.checked }))}
            />
            Make available to all users?
          </label>

          <label className="auth-field">
            <span className="ww-label">CSV File</span>
            <input
              className="auth-input auth-input--file"
              type="file"
              accept=".csv"
              required
              onChange={(e) => setForm((c) => ({ ...c, file: e.target.files[0] || null }))}
            />
          </label>

          <div className="auth-actions">
            <button type="submit" className="ww-btn ww-btn--primary">Submit</button>
            <button
              type="button"
              className="ww-btn ww-btn--secondary"
              onClick={() => navigate("/wordy-whiz/my-dictionaries")}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default Upload;
